import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	documentType: null,
	error: "",
	loading: false,
};

// ADD_state
export const addDocumentType = createAsyncThunk(
	"state/addDocumentType",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `documentType/`,
				data: {
					...values,
				},
			});
			toast.success("Document Type added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Document Type try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_documentType
export const deleteDocumentType = createAsyncThunk(
	"documentType/deleteDocumentType ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `documentType/${id}`,
			});

			toast.success("Document Type deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Document Type try again");
			console.log(error.message);
		}
	}
);

// documentTypeS
export const getAllDocumentType = createAsyncThunk(
	"documentType/getAllDocumentType",
	async () => {
		try {
			const { data } = await axios.get(`documentType/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateDocumentType = createAsyncThunk(
	"documentType/updateDocumentType",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `documentType/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Document Type updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Document Type try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const documentTypeSlice = createSlice({
	name: "documentType",
	initialState,
	reducers: {
		clearDocumentType: (state) => {
			state.documentType = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllDocumentType ======

		builder.addCase(getAllDocumentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllDocumentType.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllDocumentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addDocumentType  ======

		builder.addCase(addDocumentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addDocumentType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addDocumentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for state ======

		builder.addCase(updateDocumentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateDocumentType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateDocumentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteDocumentType  ======

		builder.addCase(deleteDocumentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteDocumentType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteDocumentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default documentTypeSlice.reducer;
export const { clearDocumentType } = documentTypeSlice.actions;
